import { TEA_EVENT_PREFIX, searchObj, envRegion } from './constants';
import { debug } from '@/utils/debug';
import { isNative } from '../utils/constants';
import { errorStack, getFp } from '../utils/utils';
import { TeaToNative } from '../service/jsbridge';
window.logIdMap = {
  get_log_id: '',
  verify_log_id: '',
  shark_log_id: '',
};
const EVT_NAME = 'turing_verify_sdk';
let fp = '';
let isScheduling = false;
const TeaPromise = import(
  /* webpackChunkName: "t" */
  /* webpackMode: "lazy" */ process.env.TEA_NPM_NAME as string
);

function delay(ms: number) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), ms);
  });
}

type TeaInstance = {
  default?: any;
  va?: any;
};
let teaInstance: TeaInstance = {};
let cmnParams = {};
export async function init(
  evtParams: CaptchaOptions,
  teaName: keyof TeaInstance = 'default'
) {
  // 采用实例化tea的方式，避免跟业务方tea冲突
  let Collector = (await TeaPromise).Collector;
  let Tea = new Collector(teaName);
  cmnParams = evtParams;
  const teaInitParams: any = {
    app_id: 498361,
    channel: evtParams.region === 'boe' ? 'cn' : evtParams.region,
  };
  if (envRegion === 'ttp' || envRegion === 'ttp2') {
    // ttp 是 MT 美国区域
    teaInitParams.channel_type = envRegion
  } else if (+evtParams.aid === 1180 || +evtParams.aid === 1233) {
    // 目前这个 tcpy 是专用于 MT 的，做过 tcpy 处理，且上报域名写死了 tiktok 的
    teaInitParams.channel_type = 'tcpy';
  }
  try {
    Tea.init(teaInitParams);
  } catch (error) {
    debug('TEA init error!');
  }

  if (!fp) fp = getFp();
  evtParams.fp = fp;
  evtParams.product_host = window.location.host;
  evtParams.product_path = window.location.pathname;
  // 设置通参
  const conf: any = {
    user_unique_id: isNative ? evtParams.did : fp,
    evtParams,
  };
  if (isNative) {
    conf.reportErrorCallback = (eventData: any, errorCode: any) => {
      eventData.forEach((eventItem: any) => {
        eventItem.events.forEach((oneEvent: any) => {
          let params = JSON.parse(oneEvent.params);
          params.event = oneEvent.event;
          params = Object.assign(evtParams, params);
          window.captchaFailEvents.push(JSON.stringify(params));
        });
      });
    };
  }
  try {
    Tea.config(conf);
    Tea.start();
    teaInstance[teaName] = Tea;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('TEA init error!');
  }
  return Tea;
}

export function setScheduling(bool: boolean) {
  isScheduling = bool;
}
// 默认埋点请求预处理
export async function trackEvent(evtName: string, evtParams?: any) {
  await TeaPromise;
  const params = {
    key: TEA_EVENT_PREFIX + evtName,
    ...cmnParams,
    ...evtParams,
    ...window.logIdMap,
  };
  try {
    if (searchObj.use_native_report === '1') {
      TeaToNative({
        event: EVT_NAME,
        ...params,
      });
    } else if (teaInstance.default) {
      // 对于旧版埋点不作处理，老版埋点都是verify_开头，后续会逐步删掉老版埋点
      params.time = Date.now(); // 事件埋点时间
      params.isScheduling = String(isScheduling);
      if (evtName !== 'init' && params.is_success === 0) {
        errorStack.push({
          action: evtName,
          msg: params.msg,
          time: params.time,
        });
        errorStack.finalStage = evtName;
      }
      errorStack.finalStage = evtName;

      debug(
        'log event ****************',
        'evtName',
        evtName,
        'evtParams',
        params
      );
      teaInstance.default.event(EVT_NAME, params);
    }
  } catch (error) {
    debug('trackEvent error!');
  }
}

export async function batchSendEvents(evtsArr: any) {
  debug('batch log events ****************', evtsArr);
  window.captchaFailEvents = [];
  // 此处设置250是把从客户端拿到的200个事件和本地的一些失败事件一起重新发送，如果超过250个的话，超出的部分在重新存储，等待下次批量发送
  if (evtsArr.length > 250) {
    window.captchaFailEvents = evtsArr.splice(250);
  }
  evtsArr.forEach((item: any) => {
    const info = JSON.parse(item);
    if (teaInstance.default) {
      teaInstance.default.event(info.event, info);
    }
  });
  await delay(5000); // 设置5秒为了尽量让所有失败事件都埋点
}

export const setParams = (params: Obj) => {
  cmnParams = {
    ...cmnParams,
    ...params,
  };
};

export const getParams = () => {
  return cmnParams;
};
